import PropTypes from 'prop-types';
import { AccountDefaults, AccountProps } from './account';
import { ApiKeyDefaults, ApiKeyProps } from './apiKey';

export const CurrentUserProps = PropTypes.shape({
  loggedIn: PropTypes.bool,
  isDeveloper: PropTypes.bool,
  isTier1Developer: PropTypes.bool,
  isTier2Developer: PropTypes.bool,
  account: AccountProps,
  apiKey: ApiKeyProps
});

export const CurrentUserDefaults = {
  loggedIn: false,
  isDeveloper: false,
  isTier1Developer: false,
  isTier2Developer: false,
  account: AccountDefaults,
  apiKey: ApiKeyDefaults
};
